import React, {useState, useRef} from 'react';
import {TopBar} from '@shopify/polaris';
import {SearchProvider} from '@thinkwell/react.common';
import {AppProvider} from '@thinkwell/react.polaris';
import { ContentProvider } from '../contexts/Content'
import Content from './Content'
import EditContent from './EditContent'
import MainFrame from '../MainFrame';

export default function Show(props) {
  const navigateToRef = useRef()
  const [search, setSearch] = useState()
  const [addContentActive, setAddContentActive] = useState(false);
  const [isContentMenuOpen, setIsContentMenuOpen] = useState(false);
  const toggleIsContentMenuOpen = () => setIsContentMenuOpen((isContentMenuOpen) => !isContentMenuOpen);

  const contentMenuMarkup = (
     <TopBar.UserMenu
       actions={[
         {
           items: [
             {content: 'Add Content', onAction: () => { setAddContentActive(true) }},
             {content: 'Logout', url: '/logout'}
           ]
         }
       ]}
       name="Contents"
       initials="T"
       open={isContentMenuOpen}
       onToggle={toggleIsContentMenuOpen}
     />
   );

  const onSearchKeyPress = (event) => {
    const enterKeyPressed = event.keyCode === 13;
    if (enterKeyPressed) {
      event.preventDefault();
      navigateToRef.current(`content?type=${props.type}&q=${encodeURIComponent(search)}`)
    }
  }

  const onSearchChange = (value) => {
    setSearch(value)
  }

  const onAddContent = (content) => {
    navigateToRef.current(`content/${content.id}?type=${props.type}`)
  }

  const onDeleteContent = (content) => {
    navigateToRef.current(`content?type=${props.type}`)
  }

  return (
  <AppProvider>
    <SearchProvider>
      <MainFrame searchPlaceHolder={props.item && props.item.name} onSearchChange={onSearchChange}
      onSearchKeyPress={onSearchKeyPress} navigateToRef={navigateToRef} userMenu={contentMenuMarkup}>
        <ContentProvider value={props.item}>
          { addContentActive ?
            <EditContent
              active={addContentActive}
              type={props.type}
              onActive={(active) => { if (active != addContentActive) { setAddContentActive(active) }}}
              onSave={onAddContent}
            /> : null
          }
          <div style={{display: addContentActive ? 'none' : 'block'}}>
            <Content
              type={props.type}
              onDelete={onDeleteContent}
              navigateToRef={navigateToRef} />
          </div>
        </ContentProvider>
      </MainFrame>
    </SearchProvider>
  </AppProvider>)
}
